//#region src/types/event.types.ts
var e = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderAlreadyDiscovered: "OrderAlreadyDiscovered",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, t = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, n = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
export { e as n, t as r, n as t };
